import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgGridColumnsSettingService {

  public isCustomizerLayoutOpen = new BehaviorSubject<{ state: string, storageName: string }>({ state: '', storageName: '' });
  sidebarRow = new Subject<[{checked:boolean, name:string}]>();
  columnOrderChanged = new Subject<{ storageName: string, columnState: any[] }>();
  constructor() { }
}
